'use strict';

angular.module('eva2-angular').filter('capitalize', function() {
  return function(input) {
    return (!!input && input.length > 0) ? input.charAt(0).toUpperCase() + input.substr(1).toLowerCase() : '';
  };
});
